// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2MZVO","text":"SelectPayment_text__3j3AP","title":"SelectPayment_title__2YhdF","btn":"SelectPayment_btn__1mkA3"};